import React, { useEffect, useState } from "react";
import { config, storeConfig } from "../../config/config";
import "./storeDetails.scss";
import "../message/message.scss";
import { postMessageToClient } from "../chatservice/communicationService";
import { getStoreStatus, handleAnalyticsBot } from "../util/commonUtil";
import { addAnalyticsEvent } from "../chatservice/dialogflowQuery";
import { v4 } from "uuid";

type storeDetailProps = {
  store: any;
  isHostDevice: boolean;
  sessionId: any;
  userId: any;
};

const StoreDetails = ({
  store,
  isHostDevice,
  sessionId,
  userId,
}: storeDetailProps) => {
  const [isDelivery, setIsDelivery] = useState<boolean>(
    store.data.isDeliveryEnabled
  );
  const [isPickup, setIsPickup] = useState<boolean>(
    store.data.isClickAndCollectEnabled
  );
  const [isDriveThrough, setIsDriveThrough] = useState(
    store.data.facilities.includes("Drive Thru")
  );
  const [storeContact, setstoreContact] = useState(store.data.phone);
  const [tomorrowDay, setTomorrowDay] = useState<any>();

  const [timeStr1, timeStr2] = store.data.store_trading_hours || ["", ""];
  const [statusBackground, setStatusBackground] = useState("");
  const [storeCurrentStatus, setStoreCurrentStatus] = useState("");
  const [storeTradingHours, setStoreTradingHours] = useState("");

  const getDirection = () => {
    window.open(
      `${storeConfig.GOOGLE_MAP_API_DIRECTION_URL}${store.data.division}, ${store.data.addressLine1}, ${store.data.suburb}`,
      "_blank"
    );
  };

  const callNumber = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const analyticsData = {
      queryId: v4(),
      isSuccessful: false,
      eventName: "CALL_TELNO",
      intentGroupId: store.intentPayload.intentGroupId,
      intentGroupName: store.intentPayload.intentGroupName,
      intentGroupTypeId: store.intentPayload.intentGroupTypeId,
      source: config.SOURCE,
    };

    // FAW Set Store in Analytics
    addAnalyticsEvent(sessionId, userId, analyticsData);
    window.location.href = "tel:" + storeContact;
  };

  useEffect(() => {
    let todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + 1);
    let day = new Date(todayDate);
    let dayName = day.toString().split(" ")[0];
    setTomorrowDay(dayName);

    //calling a function to get store current status
    const status = getStoreStatus(store.data);

    setStoreTradingHours(status.storeTradingHours);
    setStoreCurrentStatus(status.StoreCurrentStatus);
    setStatusBackground(status.StatusBackground);

  }, []);

  return (
    <div className="storeDetail">
      <div className="storeDetail__location">
        <div className="storeDetail__title">
          BWS{" "}
          <span className="storeDetail__suburb">
            {store.data.name.toLowerCase()}
          </span>
        </div>
        {store.data.distance && (
          <div className="storeDetail__distance">{store.data.distance} km</div>
        )}
      </div>

      <div className="storeDetail__facilities">
        {isDelivery ? (
          <div className="delivery">
            <img
              className="product__facilities-isAvailable"
              src="/images/Vector-correct.svg"
              alt=""
            />
            <span> Delivery</span>
          </div>
        ) : (
          ""
        )}
        {isPickup ? (
          <div className="pickUp">
            <img
              className="product__facilities-isAvailable"
              src="/images/Vector-correct.svg"
              alt=""
            />
            <span> Pick up</span>
          </div>
        ) : (
          ""
        )}

        {isDriveThrough ? (
          <div className="driveThrough">
            <img
              className="product__facilities-isAvailable"
              src="/images/Vector-correct.svg"
              alt=""
            />
            <span> Drive through</span>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="storeDetail__address">
        <span>
          {store.data.addressLine1}, {store.data.state} {store.data.postCode}
        </span>
      </div>

      <div className="storeDetail__suburb-status">
        <div className="storeDetail__status">
          <span className={"storeDetail__status-today " + statusBackground}>
            {storeCurrentStatus}
          </span>
          <span className={store?.data?.trading_hours_all[0]?.simpleTradingStatus[0]?.toLowerCase() === "closed" ? 'storeClosed' : 'storeOpened'}>{storeTradingHours}</span>
        </div>

        <div className="storeDetail__week-status">
          {store.data.trading_hours_all?.map((day: any, index: any) => {
            return (
              <div key={index}>
                {index != 0 ? (
                  index != 7 ? (
                    <div className="storeDetail__trading-Hours">
                      <span className="storeDetail__trading-Hours__day">
                        {day.day.slice(0, 3) === "Tom"
                          ? tomorrowDay
                          : day.day.slice(0, 3)}
                      </span>
                      <div className="storeDetail__trading-Hours__date">
                        <span>
                          {new Date(day.date).toLocaleDateString("en-us", {
                            day: "numeric",
                          })}
                        </span>
                        <span>
                          {new Date(day.date).toLocaleDateString("en-us", {
                            month: "short",
                          })}
                        </span>
                      </div>

                      <span className="storeDetail__trading-Hours__openHour">
                        {day.openHour.toLowerCase() !== "closed" ? (
                          <div>
                            <span className="storeDetail__trading-Hours__openHour-time">
                              {day.openHour.split("-")[0].toUpperCase()}
                            </span>
                            <span className="storeDetail__trading-Hours__openHour-separator">
                              {" "}
                              -
                            </span>
                            <span className="storeDetail__trading-Hours__openHour-time">
                              {day.openHour.split("-")[1].toUpperCase()}
                            </span>
                          </div>
                        ) : (
                          "Closed"
                        )}
                      </span>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className="storeDetail__options">
        <div className="storeDetail__contact">
          <img src="/images/Vector-call-icon.svg" alt="" />

          <a onClick={callNumber}>
            <span>{storeContact}</span>
          </a>
        </div>
        <div className="storeDetail__direction">
          <img src="/images/Vector-direction-icon.svg" alt="" />
          <span onClick={getDirection} id="get-direction-link">
            directions
          </span>
        </div>
      </div>
    </div>
  );
};

export { StoreDetails };
